module.exports = __webpack_public_path__ + "fonts/HKNova-Light.98c98f3f.woff";